module.exports = __webpack_public_path__ + "static/media/hongkong.23b72487.png";